module.exports = __webpack_public_path__ + "static/media/1-safronova.1c4dba81.jpg";